import React, { FC } from 'react';
import { InputAdornment } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import classNames from 'classnames';

interface IProps extends WithStyles<typeof styles> {
  focused: boolean;
}

const styles = (theme: Theme) =>
  createStyles({
    icon: {
      fontSize: 28,
      transition: 'color 100ms ease-in-out',
      marginLeft: theme.spacing(1),
    },
    inactive: {
      color: theme.custom.palette.grey2,
    },
    focused: {
      color: theme.custom.palette.black1,
    },
  });

const StartAdornment: FC<IProps> = ({ classes, focused }) => {
  const searchIconClasses = classNames(classes.icon, {
    [classes.inactive]: !focused,
    [classes.focused]: focused,
  });

  return (
    <InputAdornment position="start">
      <SearchIcon className={searchIconClasses} />
    </InputAdornment>
  );
};

export default withStyles(styles)(StartAdornment);
